import { useState } from 'react';
import { XCircle, Trash2 } from 'lucide-react';

export default function PersonalPinModal({ mode, initial, onSave, onDelete, onCancel }) {
  const [label, setLabel] = useState(initial.label || "");
  const [colour, setColour] = useState(initial.colour || "#4285f4");

  return (
    <div style={{
      position: 'fixed', zIndex: 9999, left: 0, top: 0, width: '100vw', height: '100vh',
      background: 'rgba(18,18,18,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center'
    }}>
      <div style={{
        background: '#25262d', borderRadius: 15, padding: 26, minWidth: 320, maxWidth: 340,
        boxShadow: '0 2px 30px #000b', position: 'relative', color: '#fff'
      }}>
        <button
          onClick={onCancel}
          style={{ position: "absolute", top: 13, right: 13, background: "none", border: "none", color: "#eee", fontSize: 26, cursor: "pointer" }}
          title="Close"
        ><XCircle size={28}/></button>
        <div style={{ fontWeight: 700, fontSize: 17, marginBottom: 12 }}>
          {mode === "add" ? "Place Personal Pin" : "Edit Personal Pin"}
        </div>
        <div style={{ marginBottom: 14 }}>
          <label style={{ fontWeight: 500, fontSize: 14 }}>Name/Label:</label><br />
          <input
            autoFocus
            type="text"
            maxLength={32}
            style={{
              width: '100%', fontSize: 15, padding: '8px 10px',
              borderRadius: 7, border: '1.5px solid #393b49', marginTop: 2
            }}
            value={label}
            onChange={e => setLabel(e.target.value)}
            placeholder="e.g. My Base"
          />
        </div>
        <div style={{ marginBottom: 18 }}>
          <label style={{ fontWeight: 500, fontSize: 14 }}>Pin Colour:</label><br />
          <input
            type="color"
            style={{ width: 38, height: 32, border: 'none', marginTop: 4, cursor: 'pointer', background: '#181818', borderRadius: 7 }}
            value={colour}
            onChange={e => setColour(e.target.value)}
          />
          <span style={{ fontSize: 12, color: "#ffe670", marginLeft: 8 }}>{colour.toUpperCase()}</span>
        </div>
        <div style={{ display: "flex", justifyContent: 'space-between', alignItems: 'center' }}>
          {mode === "edit" &&
            <button
              onClick={onDelete}
              style={{
                background: "#f44c2b", color: "#fff", border: "none", borderRadius: 7,
                padding: "7px 18px", fontWeight: 700, fontSize: 15, cursor: "pointer"
              }}
            >Delete</button>
          }
          <button
            onClick={() => onSave({ label, colour })}
            style={{
              background: "#4cc153", color: "#fff", border: "none", borderRadius: 7,
              padding: "7px 18px", fontWeight: 700, fontSize: 15, cursor: "pointer", marginLeft: "auto"
            }}
          >Save</button>
        </div>
      </div>
    </div>
  );
}
